import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, from, map, of, switchMap } from 'rxjs';
import { ApplicationsService } from 'src/app/shared/services/applications/applications.service';
import { NotificationCentreService } from 'src/app/shared/services/notification-centre/notification-centre.service';
import { ClientStore } from 'src/app/shared/stores/client/client.store';
import { awaitClientReady } from 'src/app/shared/utils/client/client.util';

/**
 * Loads the signed-in user's notifications before the page renders. The user id comes with the
 * applications call, so that is made first when it has not run yet.
 */
export const notificationsResolver: ResolveFn<boolean> = () => {
  const clientStore = inject(ClientStore);
  const applicationsService = inject(ApplicationsService);
  const notificationCentreService = inject(NotificationCentreService);

  return from(awaitClientReady(clientStore)).pipe(
    switchMap((client) => {
      if (!client) {
        return of(false);
      }

      const userId$ = clientStore.userId()
        ? of(clientStore.userId())
        : applicationsService.get(client.clientId).pipe(map(() => clientStore.userId()));

      return userId$.pipe(
        switchMap((userId) => (userId ? notificationCentreService.load(userId).pipe(map(() => true)) : of(false)))
      );
    }),
    catchError((error) => {
      console.error('Notifications preload failed', error);
      return of(false);
    })
  );
};
